// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"3d54d070","593":"73f9ac2d","599":"baf1d437"}[chunkId] + ".chunk.css";
};